import script from "./itemV2ItemWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2ItemWidget.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2ItemWidget.vue?vue&type=style&index=0&id=bc6d1492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc6d1492"]])

export default __exports__